import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/ri.png';
import _imports_1 from '@/assets/wei.png';
import _imports_2 from '@/assets/dai.png';
const _withScopeId = n => (_pushScopeId("data-v-3690b0a4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "examine-content-list m10"
};
const _hoisted_2 = {
  class: "uni-list uni-border-top-bottom"
};
const _hoisted_3 = {
  class: "uni-list-item__container"
};
const _hoisted_4 = {
  class: "item-list"
};
const _hoisted_5 = {
  class: "checkbox"
};
const _hoisted_6 = ["value", "disabled"];
const _hoisted_7 = {
  class: "titles"
};
const _hoisted_8 = {
  class: "number"
};
const _hoisted_9 = {
  class: "title row-first"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "付款单号：", -1));
const _hoisted_11 = {
  class: "title row-second"
};
const _hoisted_12 = {
  class: "title row-first"
};
const _hoisted_13 = {
  class: "title row-second"
};
const _hoisted_14 = {
  class: "title row-first"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title row-second"
}, "付款类型：供应付款", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "clear": "both"
  }
}, null, -1));
const _hoisted_17 = {
  class: "title row-first"
};
const _hoisted_18 = {
  class: "title row-second"
};
const _hoisted_19 = {
  class: "title row-first"
};
const _hoisted_20 = {
  class: "title row-second"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "clear": "both"
  }
}, null, -1));
const _hoisted_22 = {
  class: "footer"
};
const _hoisted_23 = {
  class: "left"
};
const _hoisted_24 = {
  class: "right"
};
const _hoisted_25 = {
  key: 0,
  class: "item-list-status"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_27 = [_hoisted_26];
const _hoisted_28 = {
  key: 1,
  class: "item-list-status"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = {
  key: 2,
  class: "item-list-status"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_33 = [_hoisted_32];
const _hoisted_34 = {
  key: 0,
  style: {
    "font-size": "12px",
    "text-align": "center",
    "margin": "20px"
  }
};
const _hoisted_35 = {
  class: "date-picker"
};
const _hoisted_36 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_37 = {
  class: "wrapper"
};
const _hoisted_38 = {
  style: {
    "padding": "15px 0"
  }
};
const _hoisted_39 = {
  style: {
    "margin": "16px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
  const _component_van_tabbar = _resolveComponent("van-tabbar");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_calendar = _resolveComponent("van-calendar");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_overlay = _resolveComponent("van-overlay");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_SearchSelect = _resolveComponent("SearchSelect");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    fixed: true,
    title: "供应付款"
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.collectionlist, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "uni-list-item content-item-list",
      key: index
    }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.checked = $event),
      value: item.id,
      disabled: item.status === '已提交',
      shape: "square"
    }, null, 8, _hoisted_6), [[_vModelCheckbox, $data.checked]])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, _toDisplayString(item.SettlementName), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.Amount), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createTextVNode(_toDisplayString(item.ReceivablesPaymentNumber), 1)]), _createElementVNode("div", _hoisted_11, "付款日期：" + _toDisplayString(item.PaymentDate), 1), _createElementVNode("div", _hoisted_12, "对方银行：" + _toDisplayString(item.SettlementBankName), 1), _createElementVNode("div", _hoisted_13, "工程：" + _toDisplayString(item.ProjectShortName), 1), _createElementVNode("div", _hoisted_14, "对方账号：" + _toDisplayString(item.SBankAccount), 1), _hoisted_15, _hoisted_16, _createVNode(_component_van_divider, {
      dashed: "",
      style: {
        height: '1px',
        lineHeight: '1px'
      }
    }), _createElementVNode("div", _hoisted_17, "我方银行：" + _toDisplayString(item.MyAccountNature), 1), _createElementVNode("div", _hoisted_18, "公司：" + _toDisplayString(item.CompanyName), 1), _createElementVNode("div", _hoisted_19, "我方账号：" + _toDisplayString(item.MyBankAccount), 1), _createElementVNode("div", _hoisted_20, "用途：" + _toDisplayString(item.purpose), 1), _hoisted_21, _createVNode(_component_van_divider, {
      dashed: "",
      style: {
        height: '1px',
        lineHeight: '1px'
      }
    }), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(item.AttnName) + " 经办 ", 1), _createElementVNode("div", _hoisted_24, _toDisplayString(item.PaymentDate), 1)]), item.status === '已提交' ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27)) : item.ApproveState === '未审批' ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30)) : item.status === '未提交' ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33)) : _createCommentVNode("", true)])])]);
  }), 128)), $data.finished ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString($data.finishedtext), 1)) : _createCommentVNode("", true)])]), _createVNode(_component_van_tabbar, {
    modelValue: $data.active,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.active = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      icon: "search",
      onClick: $options.searchs
    }, {
      default: _withCtx(() => [_createTextVNode("搜索")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_tabbar_item, {
      icon: "add-o",
      onClick: $options.applypay
    }, {
      default: _withCtx(() => [_createTextVNode("申请")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_tabbar_item, {
      icon: "completed",
      onClick: $options.selectAll
    }, {
      default: _withCtx(() => [_createTextVNode("全选")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_tabbar_item, {
      icon: "completed",
      onClick: $options.approval
    }, {
      default: _withCtx(() => [_createTextVNode("审批")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_tabbar_item, {
      icon: "passed",
      onClick: $options.onClickRight
    }, {
      default: _withCtx(() => [_createTextVNode("提交")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_van_popup, {
    show: $data.showsearch,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.showsearch = $event),
    position: "top",
    closeable: "",
    style: {
      height: '28%'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createVNode(_component_van_cell, {
      title: "日期",
      "is-link": "",
      value: $data.searchdate,
      onClick: _cache[2] || (_cache[2] = $event => {
        $data.showdate = true;
        $data.type = 1;
      })
    }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_36, [_createVNode(_component_van_button, {
      type: "primary",
      size: "small",
      style: {
        "width": "80%"
      },
      onClick: $options.search
    }, {
      default: _withCtx(() => [_createTextVNode("搜 索")]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_calendar, {
    show: $data.showdate,
    "onUpdate:show": _cache[4] || (_cache[4] = $event => $data.showdate = $event),
    onConfirm: $options.onConfirm,
    "min-date": $data.minDate,
    "max-date": $data.maxDate
  }, null, 8, ["show", "onConfirm", "min-date", "max-date"]), _createVNode(_component_van_overlay, {
    show: $data.show,
    "z-index": "99999"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_createVNode(_component_van_loading, {
      size: "24px"
    }, {
      default: _withCtx(() => [_createTextVNode("加载中...")]),
      _: 1
    })])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.showBottom,
    "onUpdate:show": _cache[25] || (_cache[25] = $event => $data.showBottom = $event),
    position: "bottom",
    closeable: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_createVNode(_component_van_form, {
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: $data.datainfo.PaymentDate,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.datainfo.PaymentDate = $event),
          "is-link": "",
          readonly: "",
          name: "PaymentDate",
          label: "日历",
          placeholder: "点击选择日期",
          onClick: _cache[6] || (_cache[6] = $event => {
            $data.showdate = true;
            $data.type = 3;
          }),
          rules: [{
            required: true,
            message: '请选择日期'
          }]
        }, null, 8, ["modelValue"]), $options.isSupplierPay ? (_openBlock(), _createBlock(_component_van_field, {
          key: 0,
          modelValue: $data.datainfo.SettlementName,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.datainfo.SettlementName = $event),
          "is-link": "",
          readonly: "",
          name: "SettlementName",
          label: "供应商",
          placeholder: "点击选择供应商",
          onClick: $options.openSupplierSelect,
          rules: $options.isSupplierPay ? [{
            required: true,
            message: '请选择供应商'
          }] : []
        }, null, 8, ["modelValue", "onClick", "rules"])) : _createCommentVNode("", true), $options.isSupplierPay ? (_openBlock(), _createBlock(_component_van_field, {
          key: 1,
          modelValue: $data.accountText.supplier,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.accountText.supplier = $event),
          "is-link": "",
          readonly: "",
          onClick: $options.openSupplierAccountSelect,
          name: "AccountType",
          label: "供应商账户",
          placeholder: "请选择供应商后选择账户",
          rules: $options.isSupplierPay ? [{
            required: true,
            message: '请选择供应商账户'
          }] : []
        }, null, 8, ["modelValue", "onClick", "rules"])) : _createCommentVNode("", true), $options.isCustomerPay ? (_openBlock(), _createBlock(_component_van_field, {
          key: 2,
          modelValue: $data.datainfo.SettlementName,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.datainfo.SettlementName = $event),
          "is-link": "",
          readonly: "",
          onClick: $options.openCustomerSelect,
          name: "CustomerName",
          label: "客户",
          placeholder: "点击选择客户",
          rules: $options.isCustomerPay ? [{
            required: true,
            message: '请选择客户'
          }] : []
        }, null, 8, ["modelValue", "onClick", "rules"])) : _createCommentVNode("", true), $options.isCustomerPay ? (_openBlock(), _createBlock(_component_van_field, {
          key: 3,
          modelValue: $data.accountText.customer,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.accountText.customer = $event),
          "is-link": "",
          readonly: "",
          onClick: $options.openCustomerAccountSelect,
          name: "CustomerAccountId",
          label: "客户账户",
          placeholder: "请选择客户后选择账户",
          rules: $options.isCustomerPay ? [{
            required: true,
            message: '请选择客户账户'
          }] : []
        }, null, 8, ["modelValue", "onClick", "rules"])) : _createCommentVNode("", true), _createVNode(_component_van_field, {
          modelValue: $data.datainfo.CompanyName,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.datainfo.CompanyName = $event),
          "is-link": "",
          readonly: "",
          onClick: _cache[12] || (_cache[12] = $event => $options.clickPicker('CompanyName', 5)),
          name: "CompanyName",
          label: "公司",
          placeholder: "公司",
          rules: [{
            required: true,
            message: '请选择公司'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.datainfo.Amount,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.datainfo.Amount = $event),
          name: "Amount",
          label: "金额",
          placeholder: "金额",
          rules: [{
            required: true,
            message: '请填写金额'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.datainfo.AttnName,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.datainfo.AttnName = $event),
          "is-link": "",
          readonly: "",
          onClick: _cache[15] || (_cache[15] = $event => $options.clickPicker('AttnName', 6)),
          name: "AttnName",
          label: "经办人",
          placeholder: "经办人",
          rules: [{
            required: true,
            message: '请选择经办人'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.datainfo.PaymentBussTypeName,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.datainfo.PaymentBussTypeName = $event),
          name: "PaymentBussTypeName",
          "is-link": "",
          readonly: "",
          onClick: _cache[17] || (_cache[17] = $event => $options.clickPicker('PaymentBussTypeName', 7)),
          label: "付款类型",
          placeholder: "付款类型",
          rules: [{
            required: true,
            message: '请选择付款类型'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.datainfo.PaymentTermsName,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.datainfo.PaymentTermsName = $event),
          name: "PaymentTermsName",
          "is-link": "",
          readonly: "",
          onClick: _cache[19] || (_cache[19] = $event => $options.clickPicker('PaymentTermsName', 8)),
          label: "支付方式",
          placeholder: "支付方式",
          rules: [{
            required: true,
            message: '请选择支付方式'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.datainfo.purpose,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.datainfo.purpose = $event),
          name: "purpose",
          label: "用途",
          placeholder: "用途"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.datainfo.Memo,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.datainfo.Memo = $event),
          name: "Memo",
          label: "备注",
          placeholder: "备注"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.datainfo.ProjectShortName,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.datainfo.ProjectShortName = $event),
          "is-link": "",
          readonly: "",
          onClick: $options.openProjectSelect,
          name: "ProjectShortName",
          label: "工程",
          placeholder: "点击选择工程"
        }, null, 8, ["modelValue", "onClick"]), _createVNode(_component_van_field, {
          modelValue: $data.datainfo.TeamName,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.datainfo.TeamName = $event),
          "is-link": "",
          readonly: "",
          onClick: _cache[24] || (_cache[24] = $event => $options.clickPicker('TeamName', 10)),
          name: "TeamName",
          label: "业务组",
          placeholder: "业务组"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createElementVNode("div", _hoisted_39, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        "native-type": "submit"
      }, {
        default: _withCtx(() => [_createTextVNode(" 提交 ")]),
        _: 1
      })])]),
      _: 1
    }, 8, ["onSubmit"])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.showPicker,
    "onUpdate:show": _cache[27] || (_cache[27] = $event => $data.showPicker = $event),
    "destroy-on-close": "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      columns: $data.columns,
      "model-value": _ctx.pickerValue,
      onConfirm: $options.onColumns,
      onCancel: _cache[26] || (_cache[26] = $event => $data.showPicker = false)
    }, null, 8, ["columns", "model-value", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_SearchSelect, {
    show: $data.showSupplierSelect,
    "onUpdate:show": _cache[28] || (_cache[28] = $event => $data.showSupplierSelect = $event),
    title: "选择供应商",
    list: $data.supplierlist,
    "model-value": $data.supplierId,
    placeholder: "输入供应商名称搜索",
    onConfirm: $options.onSupplierConfirm
  }, null, 8, ["show", "list", "model-value", "onConfirm"]), _createVNode(_component_SearchSelect, {
    show: $data.showCustomerSelect,
    "onUpdate:show": _cache[29] || (_cache[29] = $event => $data.showCustomerSelect = $event),
    title: "选择客户",
    list: $data.customerlist,
    "model-value": $data.customerId,
    placeholder: "输入客户名称搜索",
    onConfirm: $options.onCustomerConfirm
  }, null, 8, ["show", "list", "model-value", "onConfirm"]), _createVNode(_component_SearchSelect, {
    show: $data.showSupplierAccountSelect,
    "onUpdate:show": _cache[30] || (_cache[30] = $event => $data.showSupplierAccountSelect = $event),
    title: "选择供应商账户",
    "model-value": $data.supplierAccountId,
    "remote-method": $options.searchSupplierAccount,
    placeholder: "输入银行/账号搜索",
    onConfirm: $options.onSupplierAccountConfirm
  }, null, 8, ["show", "model-value", "remote-method", "onConfirm"]), _createVNode(_component_SearchSelect, {
    show: $data.showProjectSelect,
    "onUpdate:show": _cache[31] || (_cache[31] = $event => $data.showProjectSelect = $event),
    title: "选择工程",
    list: $data.projectlist,
    "model-value": $data.projectId,
    placeholder: "输入工程名称搜索",
    onConfirm: $options.onProjectConfirm
  }, null, 8, ["show", "list", "model-value", "onConfirm"]), _createVNode(_component_SearchSelect, {
    show: $data.showCustomerAccountSelect,
    "onUpdate:show": _cache[32] || (_cache[32] = $event => $data.showCustomerAccountSelect = $event),
    title: "选择客户账户",
    "model-value": $data.customerAccountId,
    "remote-method": $options.searchCustomerAccount,
    placeholder: "输入银行/账号搜索",
    onConfirm: $options.onCustomerAccountConfirm
  }, null, 8, ["show", "model-value", "remote-method", "onConfirm"])]);
}